import { dialogTitleClasses, iconButtonClasses, dialogContentClasses, dialogActionsClasses } from "@mui/material";
const MuiPopover = {
  defaultProps: {},
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: "24px",
      [`& .${dialogTitleClasses.root}`]: {
        display: "flex",
        alignItems: "flex-start",
        background: theme.palette.primary[75],
        color: theme.palette.primary[900],
        padding: "16px 16px 16px 24px",
        [`& .${iconButtonClasses.root}`]: {
          margin: "0 0 0 16px",
          padding: 0,
          color: theme.palette.grey[700]
        }
      },
      [`&& .${dialogContentClasses.root}`]: {
        padding: "8px 24px"
      },
      [`& .${dialogActionsClasses.root}`]: {
        padding: "24px"
      }
    })
  }
};
export {
  MuiPopover
};
